import 'css-chunk:src/components/widgets/Image/LazyImage.scss';export default {
  "LazyImage": "_LazyImage_1lo6x_1",
  "fadeIn": "_fadeIn_1lo6x_1",
  "completed": "_completed_1lo6x_6"
};